import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Color Mode Toggles"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "color-mode-toggles"
    }}>{`Color Mode Toggles`}</h1>
    <p>{`Create a button to toggle between light and dark `}<a parentName="p" {...{
        "href": "/color-modes"
      }}>{`color modes`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx, useColorMode } from 'theme-ui'

export default props => {
  const [ mode, setMode ] = useColorMode()

  return (
    <button
      {...props}
      onClick={e => {
        const next = mode === 'dark' ? 'light' : 'dark'
        setMode(next)
      }}
    />
  )
}
`}</code></pre>
    <h2 {...{
      "id": "cycling-through-multiple-modes"
    }}>{`Cycling through multiple modes`}</h2>
    <p>{`Create a button to cycle through multiple `}<a parentName="p" {...{
        "href": "/color-modes"
      }}>{`color modes`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx, useColorMode } from 'theme-ui'

const modes = [
  'light',
  'dark',
  'purple',
  'pink',
]

export default props => {
  const [ mode, setMode ] = useColorMode()

  return (
    <button
      {...props}
      onClick={e => {
        const index = modes.indexOf(mode)
        const next = modes[(index + 1) % modes.length]
        setMode(next)
      }}
    />
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      